import { gql } from 'graphql-tag';

const CreateEventEvidenceMutation = gql`
  mutation createEventEvidence(
    $eventId: ID!
    $folderNumber: Int!
    $evidenceId: ID!
    $orderIndex: Int!
    $requiredActors: Int!
  ) {
    createEventEvidence(
      eventId: $eventId
      folderNumber: $folderNumber
      evidenceId: $evidenceId
      orderIndex: $orderIndex
      requiredActors: $requiredActors
    ) {
      id
      eventId
      evidenceId {
        id
        name
      }
      folderNumber
      orderIndex
      requiredActors
      createdAt
      updatedAt
      deletedAt
    }
  }
`;

export const createEventEvidence = async ({ client, params }) => {
  params.data.evidenceId = params.data.evidence;

  const result = await client.mutate({
    mutation: CreateEventEvidenceMutation,
    variables: { ...params.data },
  });

  return result.data;
};
